<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'CustomerList',
})
</script>
<template>
    <a-card :bordered="false">
        <div class="table-page-search-wrapper">
            <a-form>
                <a-row :gutter="48">
                    <a-col :md="6" :sm="24">
                        <a-form-item label="平台名称" name="platform_id">
                            <a-select allow-clear mode="multiple" v-model:value="queryParam.platform_id"
                                placeholder="请选择平台">
                                <a-select-option v-for="(item, index) in data.platformList" :key="index"
                                    :value="item.id">{{ item.platform_abbreviation }}</a-select-option>
                            </a-select>
                        </a-form-item>
                    </a-col>
                    <a-col :md="6" :sm="24">
                        <a-form-item label="公司名称" name="nameOrCode">
                            <a-input @keyup.enter="loadData" v-model:value="queryParam.nameOrCode"
                                placeholder="请输入公司名称、税号"> </a-input>
                        </a-form-item>
                    </a-col>
                    <a-col :md="6" :sm="24">
                        <a-form-item label="续费号码" name="xftel">
                            <a-input @keyup.enter="loadData" v-model:value="queryParam.xftel" placeholder="请输入">
                            </a-input>
                        </a-form-item>
                    </a-col>

                    <a-col :md="6" :sm="24">
                        <a-form-item label="代理商姓名" name="seller">
                            <a-input @keyup.enter="loadData" v-model:value="queryParam.seller" placeholder="请输入">
                            </a-input>
                        </a-form-item>
                    </a-col>

                    <a-col :md="6" :sm="24">
                        <a-form-item label="法人代表姓名" name="fr_name">
                            <a-input @keyup.enter="loadData" v-model:value="queryParam.fr_name" placeholder="请输入">
                            </a-input>
                        </a-form-item>
                    </a-col>

                    <template v-if="data.advanced">
                        <a-col :md="6" :sm="24" v-if="user.username == 'wanduo' || user.username == 'admin'">
                            <a-form-item label="法人代表姓名" name="fr_name">
                                <a-input @keyup.enter="loadData" v-model:value="queryParam.fr_name" placeholder="请输入">
                                </a-input>
                            </a-form-item>
                        </a-col>
                        <a-col :md="6" :sm="24">
                            <a-form-item label="地址编号" name="address_number">
                                <a-input @keyup.enter="loadData" v-model:value="queryParam.address_number"
                                    placeholder="请输入"> </a-input>
                            </a-form-item>
                        </a-col>
                        <a-col :md="6" :sm="24">
                            <a-form-item label="入驻类型" name="business_type">
                                <a-select allow-clear mode="multiple" v-model:value="queryParam.business_type"
                                    placeholder="请选择">
                                    <a-select-option :value="1">设立</a-select-option>
                                    <a-select-option :value="2">同区迁入</a-select-option>
                                    <a-select-option :value="3">跨区迁入</a-select-option>
                                </a-select>
                            </a-form-item>
                        </a-col>
                    </template>
                    <a-col :md="6" :sm="24">
                        <a-form-item label="主体类型" name="main_type">
                            <a-select allow-clear mode="multiple" v-model:value="queryParam.main_type"
                                placeholder="请选择">
                                <a-select-option :value="1">公司</a-select-option>
                                <a-select-option :value="2">个体</a-select-option>
                                <a-select-option :value="3">个人独资</a-select-option>
                                <a-select-option :value="4">合伙企业</a-select-option>
                            </a-select>
                        </a-form-item>
                    </a-col>

                    <a-col :md="6" :sm="24">
                        <a-form-item label="主体状态" name="exception_flag">
                            <a-select allow-clear mode="multiple" v-model:value="queryParam.exception_flag"
                                placeholder="请选择" :disabled="data.exception_flag_disabled">
                                <a-select-option :value="1">正常状态</a-select-option>
                                <a-select-option :value="2">待申报异常【代理商待确认①】</a-select-option>
                                <a-select-option :value="3">待申报异常【代理商已确认，公司待确认②】</a-select-option>
                                <a-select-option :value="4">待申报异常【代理商、公司已确认，准备提交资料③】</a-select-option>
                                <a-select-option :value="5">已申报异常【已交资料，待确认是否地址异常】</a-select-option>
                                <a-select-option :value="6">人工已确认地址已异常</a-select-option>
                            </a-select>
                        </a-form-item>
                    </a-col>
                    <a-col :md="6" :sm="24">
                        <a-form-item label="到期时间" name="between_end">
                            <a-range-picker :show-time="{ defaultValue: arrayMonent }" :value="rangEnd"
                                @change="rangEndChange" :format="format"></a-range-picker>
                        </a-form-item>
                    </a-col>
                    <a-col :md="6" :sm="24">
                        <div class="table-page-search-submitButtons" style="overflow: hidden; margin-bottom: 0">
                            <a-button type="primary" @click="loadtaizhang" v-if="data.showtype == 2">查询</a-button>
                            <a-button type="primary" @click="loadData" v-else>查询</a-button>

                            <a @click="toggleAdvanced" style="margin-left: 8px">
                                {{ data.advanced ? '收起' : '展开' }}
                                <UpOutlined v-if="data.advanced" />
                                <DownOutlined v-else />
                            </a>
                            <a-popover title="导出参数配置" trigger="click" :overlayStyle="{ width: '60%' }" placement="left"
                                v-model:open="exportDataArgumentChecked.visible">
                                <template #content>
                                    <a-tabs v-model:activeKey="exportDatatab">
                                        <a-tab-pane key="1" tab="根据搜索参数直接导出"><a-descriptions :column="1">
                                                <a-descriptions-item label="导出版本" :contentStyle="{ paddingTop: '10px' }"
                                                    :labelStyle="{ paddingTop: '10px' }">
                                                    <a-button
                                                        @click="selectExportDataArgument(1)">精简版</a-button><a-divider
                                                        type="vertical" /> <a-button
                                                        @click="selectExportDataArgument(2)">全能版</a-button><a-divider
                                                        type="vertical" />
                                                    <a-button @click="selectExportDataArgument(3)">取消选择</a-button>
                                                </a-descriptions-item>
                                                <a-descriptions-item label="导出字段">
                                                    <a-checkbox-group
                                                        v-model:value="exportDataArgumentChecked.checkedfieldSimple"
                                                        name="checkboxgroup" :options="exportDataArgument" />
                                                </a-descriptions-item>
                                                <a-descriptions-item :contentStyle="{ paddingLeft: '62px' }">
                                                    <a-button style="margin-left: 8px; display: inline-flex"
                                                        :icon="h(SvgIcon, { name: 'excel' })" @click="exportClick(1)"
                                                        :loading="data.exportLoading">导出</a-button>
                                                </a-descriptions-item>
                                            </a-descriptions></a-tab-pane>
                                        <a-tab-pane key="2" tab="根据输入的公司名称导出详细信息（选择此项，搜索条件将失效）"><a-descriptions
                                                :column="1">
                                                <a-descriptions-item label="公司名称" :contentStyle="{ paddingTop: '10px' }"
                                                    :labelStyle="{ paddingTop: '10px' }">
                                                    <a-textarea v-model:value="exportDataArgumentChecked.companylist"
                                                        placeholder="请输入公司名称" allow-clear :rows="6" />
                                                </a-descriptions-item>
                                                <a-descriptions-item label="导出版本" :contentStyle="{ paddingTop: '10px' }"
                                                    :labelStyle="{ paddingTop: '10px' }">
                                                    <a-button
                                                        @click="selectExportDataArgument(1)">精简版</a-button><a-divider
                                                        type="vertical" /> <a-button
                                                        @click="selectExportDataArgument(2)">全能版</a-button><a-divider
                                                        type="vertical" />
                                                    <a-button @click="selectExportDataArgument(3)">取消选择</a-button>
                                                </a-descriptions-item>
                                                <a-descriptions-item label="导出字段">
                                                    <a-checkbox-group
                                                        v-model:value="exportDataArgumentChecked.checkedfieldSimple"
                                                        name="checkboxgroup" :options="exportDataArgument" />
                                                </a-descriptions-item>
                                                <a-descriptions-item :contentStyle="{ paddingLeft: '62px' }">
                                                    <a-button style="margin-left: 8px; display: inline-flex"
                                                        :icon="h(SvgIcon, { name: 'excel' })" @click="exportClick(2)"
                                                        :loading="data.exportLoading">导出</a-button>
                                                </a-descriptions-item>
                                            </a-descriptions>
                                        </a-tab-pane>
                                    </a-tabs>
                                </template>
                                <a-button style="margin-left: 8px; display: inline-flex"
                                    :icon="h(SvgIcon, { name: 'excel' })" :loading="data.exportLoading">导出</a-button>
                            </a-popover>
                            <a-button v-hasPermi="['customer.list@xfcuikuan']"
                                v-if="['admin', 'platform', 'seller'].includes(data.user_permission)"
                                style="margin-left: 8px; display: inline-flex" type="primary" @click="sendCuikuan"
                                :loading="data.cuikuanLoading">发送催款通知</a-button>
                        </div>
                    </a-col>
                </a-row>
            </a-form>
        </div>
        <div class="tabs">
            <a-tabs v-model:activeKey="data.tabsExceptionKey" @change="tabsExceptionKeyChange">
                <a-tab-pane :key="1" tab="待续费客户列表"> </a-tab-pane>
                <a-tab-pane :key="2" tab="待申报异常①②③"> </a-tab-pane>
                <a-tab-pane :key="5" tab="已申报异常【已交资料，待确认是否地址异常④】"> </a-tab-pane>
                <a-tab-pane :key="6" tab="人工已确认地址已异常⑤"> </a-tab-pane>
            </a-tabs>
            <a-tabs v-model:activeKey="data.tabsExceptionKey" @change="tabsExceptionKeyChange"
                v-if="data.tabsExceptionKey == 2 || data.tabsExceptionKey == 3 || data.tabsExceptionKey == 4">
                <a-tab-pane :key="2" tab="待申报异常【代理商待确认①】"> </a-tab-pane>
                <a-tab-pane :key="3" tab="待申报异常【代理商已确认，公司待确认②】"> </a-tab-pane>
                <a-tab-pane :key="4" tab="待申报异常【代理商、公司已确认，准备提交资料③】"> </a-tab-pane>
            </a-tabs>
            <div class="tabs-right" style="right: 400px" v-if="user.id == 1">
                <a-popover trigger="click" overlayClassName="customer-options-popover">
                    <template #content>
                        <a-popconfirm title="确定批量申报异常吗?" placement="left" @confirm="piliang_shenbaoyichang()">
                            <template #description>
                                <a-form style="width: 300px" v-bind="formLayout"> 确定批量申报异常</a-form>
                            </template>
                            <p>本页批量申报异常</p>
                        </a-popconfirm>
                    </template>
                    <p style="cursor: pointer">本页批量工具</p>
                </a-popover>
            </div>
        </div>
        <div class="tabs" v-if="data.tabsExceptionKey != 1">
            <a-tabs v-model:activeKey="data.showtype" @change="loadtaizhang()">
                <a-tab-pane :key="1" tab="待办事项" v-if="data.tabsExceptionKey == 2"> </a-tab-pane>
                <a-tab-pane :key="1" tab="待办事项" v-if="data.tabsExceptionKey == 3"> </a-tab-pane>
                <a-tab-pane :key="1" tab="待办事项" v-if="data.tabsExceptionKey == 4">
                </a-tab-pane>
                <a-tab-pane :key="1" tab="待办事项" v-if="data.tabsExceptionKey == 5"> </a-tab-pane>
                <a-tab-pane :key="2" tab="台账（按时间排序）"> </a-tab-pane>
            </a-tabs>
            <a-button type="primary" :loading="data.download_sbException_loading" @click="downloadsbException"
                v-if="[2, 3, 4, 5].includes(data.tabsExceptionKey) && data.showtype == 1"
                style="position: absolute; top: 7px; left: 300px">导出待申报数据</a-button>
        </div>
        <div v-if="data.tabsExceptionKey == 1 || data.showtype == 1">
            <a-table rowClassName="tableRowClass" :columns="columns" :loading="data.loading" :data-source="dataSource"
                :pagination="pagination" @change="onChange">
                <template #bodyCell="{ column, record, index, text }">
                    <template v-if="column.dataIndex === 'companyInformation'">
                        <div class="companyInformation"
                            :style="record.exception_flag == 6 ? { borderLeft: '5px dashed #000', paddingLeft: '5px' } : {}">
                            <a-tag color="grey" v-if="record.status === 2">该主体已注销</a-tag>
                            <a-tag color="grey" v-if="record.status === 3">该主体已吊销</a-tag>
                            <a-tag color="grey" v-if="record.status === 4">该主体已迁走</a-tag>
                            <a-tag color="grey" v-if="record.status === 5">该主体已删除</a-tag>
                            <a-tag v-else-if="record.status === 6" color="grey"> 主体删除审核中，如需撤销删除，请联系管理员</a-tag>
                            <div class="mv-1x">
                                <a-popover trigger="click" v-model:open="record.isShowCompany"
                                    overlayClassName="customer-options-popover">
                                    <template #content>
                                        <p @click="handleDoubleNameClick(record.tyc_url)">跳转到天眼查</p>
                                        <p @click="handleDoubleNameClick(record.qcc_url)">跳转到企查查</p>
                                    </template>
                                    <div style="width: 100%"></div>
                                </a-popover>
                                <span class="mr-1x pointer"
                                    :style="record.status === 5 ? { textDecorationLine: 'line-through' } : {}" @click="
                                        (e) => {
                                            record.isShowCompany = false
                                            handleNameClick(e, record.full_name)
                                        }
                                    " @dblclick="
                                        () => {
                                            record.isShowCompany = true
                                        }
                                    " v-html="record.fullName"></span>
                                <a-tag class="pointer" color="#f50" @click="onDirectPaymentClick(record)"
                                    v-if="record.is_pay == 2">未支付</a-tag>
                                <a-tag color="#f50" v-else-if="record.is_pay == 3">待续费</a-tag>
                                <a-tag color="cyan" v-else-if="record.is_pay == 1">已支付√</a-tag>
                                <a-tag color="orange" v-else>状态未知</a-tag>
                                <a-tag color="green" v-if="record.business_type == 2">同区迁入</a-tag>
                                <a-tag color="green" v-if="record.business_type == 3">跨区迁入</a-tag>
                                <a-tag color="green" v-if="record.fee_standard == 2">一次性付费</a-tag>
                                <a-tag color="green" v-if="record.registration_type == 2">裸地址</a-tag>
                                <a-tag color="green" v-if="record.main_type == 3">个人独资</a-tag>
                                <a-tag color="green" v-if="record.exception_flag == 1">正常状态</a-tag>
                                <a-tag color="red" v-if="record.exception_flag == 2">待申报异常【代理商待确认①】</a-tag>
                                <a-tag color="red" v-if="record.exception_flag == 3">待申报异常【代理商已确认，公司待确认②】</a-tag>
                                <a-tag color="red" v-if="record.exception_flag == 4">待申报异常【代理商、公司已确认，准备提交资料③】</a-tag>
                                <a-tag color="red" v-if="record.exception_flag == 5">已申报异常【已交资料，待确认是否地址异常】</a-tag>
                                <a-tag color="black" v-if="record.exception_flag == 6">人工已确认地址已异常</a-tag>
                            </div>
                            <div style="margin-bottom: 8px" v-if="record.taglist">
                                <a-tag :color="item.color" v-for="(item, index) in record.taglist" :key="index">{{
                                    item.name }}</a-tag>
                            </div>
                            <div style="font-size: 13px" class="mb-x">
                                <span class="pointer" @click="handleCopyClick(record.userPositionList[0].usrename[0])">
                                    {{ record.is_filiale == 1 ? '负责人' : record.main_type == 1 ? '法人代表姓名' : '负责人' }}：
                                    {{ record.is_filiale == 1 ? record.userPositionList[6].usrename[0] :
                                        record.userPositionList[0].usrename[0] }}
                                </span>
                                <a-popover placement="right" :overlayInnerStyle="{
                                    padding: '25px'
                                }">
                                    <template #content>
                                        <div
                                            style="font-size: 16px; font-weight: 550; border-bottom: 1px dotted #ccc; padding-bottom: 8px">
                                            主体名称: {{ record.full_name }}</div>
                                        <div style="margin: 6px 0">地址：{{ record.full_address_number }}</div>
                                        <div style="margin: 6px 0" class="d-flex"
                                            v-if="record.history_names?.length > 0">
                                            <div>历史申请：</div>
                                            <div>
                                                <div v-for="(item, index) in record.history_names" :key="index">
                                                    {{ item }}
                                                </div>
                                            </div>
                                        </div>
                                        <div style="margin: 6px 0" v-if="record.social_credit_code?.length > 0">
                                            统一社会信用代码：{{ record.social_credit_code }}</div>
                                        <div style="margin: 6px 0">
                                            <span v-if="record.verify_time" class="mr-2x">核准日期：{{
                                                record.verify_time.substr(0, 10) }} </span>
                                            <span v-if="record.founding_time"> 成立日期：{{ record.founding_time.substr(0,
                                                10) }} </span>
                                        </div>
                                        <div style="margin: 6px 0">
                                            <span class="mr-2x">入驻时间：{{ record.enter_starttime.substr(0, 10) }} <span
                                                    class="mv-1x">~</span>
                                                <span v-html="record.enter_endtime"></span>
                                                <span v-if="enterTime(record.enter_endtime)" class="red">（{{
                                                    enterTime(record.enter_endtime) }}）</span>
                                            </span>
                                        </div>

                                        <div style="margin: 16px 0">
                                            <a-table :columns="shareholderColumns" rowKey="name" :pagination="false"
                                                :data-source="record.shareholder_list">
                                                <template #bodyCell="res">
                                                    <template v-if="res.column.dataIndex == 'name'">
                                                        <div>{{ res.text }}</div>
                                                        <div>工商预留电话{{
                                                            res.record.phone_number }}</div>
                                                        <div
                                                            v-if="record.permission_show_edit == 1 && res.record.phone_number_fengkong">
                                                            风控电话{{
                                                                res.record.phone_number_fengkong }}
                                                        </div>
                                                    </template>
                                                    <template v-if="res.column.dataIndex == 'id_card_number'">
                                                        <div>{{ res.text }}</div>
                                                        <div v-if="res.record.type == 1">
                                                            <a-button v-if="res.record.showidcard"
                                                                @click="res.record.showidcard = 0"
                                                                style="display: block; padding: 0"
                                                                type="link">查看身份证照片</a-button>
                                                        </div>
                                                        <div v-if="res.record.type == 2">
                                                            <a-button v-if="res.record.showidcard"
                                                                @click="res.record.showidcard = 0"
                                                                style="display: block; padding: 0"
                                                                type="link">查看营业执照照片</a-button>
                                                        </div>
                                                        <div v-if="!res.record.showidcard && res.record.type == 1">
                                                            <a-image :width="100"
                                                                :src="$store.state.user.image_domain + res.record.id_card_back"></a-image>
                                                            <a-image :width="100"
                                                                :src="$store.state.user.image_domain + res.record.id_card_front"></a-image>
                                                        </div>
                                                        <div v-if="!res.record.showidcard && res.record.type == 2">
                                                            <a-image :width="100"
                                                                :src="$store.state.user.image_domain + res.record.business_license_url"></a-image>
                                                        </div>
                                                    </template>
                                                    <template v-if="res.column.dataIndex == 'position_name'">
                                                        <div v-if="record.main_type == 1" style="max-width: 230px">
                                                            <div v-if="res.text">
                                                                <span v-for="(item, index) in res.text.split(',')"
                                                                    :key="index">
                                                                    <a-tag v-if="item?.length > 0" color="cyan">{{ item
                                                                        }}</a-tag>
                                                                </span>
                                                            </div>
                                                            <div v-else>-</div>
                                                        </div>
                                                        <div v-else>
                                                            <a-tag color="cyan">负责人</a-tag>
                                                        </div>
                                                    </template>
                                                    <template v-else-if="res.column.dataIndex == 'investment_money'">
                                                        <div v-if="res.record.is_shareholder == 1">{{ res.text }}万元
                                                        </div>
                                                        <div v-else>-</div>
                                                    </template>
                                                    <template v-else-if="res.column.dataIndex == 'subscribe_endtime'">
                                                        <div
                                                            v-if="record.main_type == 1 && res.record.is_shareholder == 1">
                                                            {{ res.text?.substr(0, 10) }}
                                                        </div>
                                                        <div v-else>-</div>
                                                    </template>
                                                </template>
                                            </a-table>
                                        </div>
                                    </template>
                                    <a type="primary" style="margin-left: 10px">更多信息</a>
                                </a-popover>
                            </div>
                            <div class="mb-x" style="font-size: 12px" v-if="record.history_names?.length > 0">
                                <span> 历史申请: </span>
                                <div v-for="(item, index) in record.history_names" :key="index">
                                    {{ item }}
                                </div>
                            </div>
                            <div style="height: 25px; font-size: 13px" v-if="record.permission_show_edit == 1">
                                <span v-html="record.lastcuikuanlog"></span><a
                                    @click="showcuikuanlog(record)">查看催款记录</a>
                                <a-switch class="ml-1x" v-model:checked="record.cuikuan_flag" :checkedValue="1"
                                    :unCheckedValue="2" checked-children="继续催款" un-checked-children="不再催款"
                                    style="margin-bottom: 6px" @click="change_cuikuan_flag(record)" size="small" />
                            </div>
                        </div>
                    </template>
                    <template v-if="column.dataIndex === 'enter_endtime'">
                        <div class="d-flex flex-ac" style="justify-content: space-between"
                            v-if="record.permission_show_edit == 1">
                            <a @click="handleCopyClick(record.xftel)">续费号码：{{
                                record.xftel }}</a><a-divider type="vertical" />
                            <a @click="showContactxf(record.id, record.xftel)">查看他所有续费</a>
                        </div>
                        <div v-if="record.customer_work_order_status">
                            <p class="mv-1x">到期时间：<span v-html="record.enter_endtime"></span></p>
                        </div>
                        <div v-else>-</div>

                        <div class="d-flex flex-ac" style="justify-content: space-between">
                            <ChangeExceptionflag :customerData="record" @change="(exception_flag) => {
                                change_exception_flag(exception_flag, record)
                            }" v-if="data.user_permission != 'shixi'">
                                <a style="font-size: 13px">调整异常状态</a>
                            </ChangeExceptionflag>
                            <a-divider type="vertical" v-if="record.exception_flag > 1" />
                            <a v-if="record.exception_flag > 1" @click="getExceptionLog(record, 1)">异常日志</a>
                            <a-divider type="vertical" />
                            <a @click="onViewLogClick(record, 1)" :offset="[5, -5]">日志</a>
                            <a-popconfirm title="确定删除?" placement="right" @openChange="
                                (e) => {
                                    openDeleteChange(e, record)
                                }
                            " @confirm="handleDelete(record)">
                                <template #description>
                                    <a-form style="width: 600px" v-bind="formLayout">
                                        <a-form-item label="删除原因" required>
                                            <a-radio-group v-model:value="record.deleteType">
                                                <a-radio :value="1">废弃</a-radio>
                                                <a-radio :value="2">该主体已注销</a-radio>
                                                <a-radio :value="3">该主体已迁出</a-radio>
                                            </a-radio-group>
                                        </a-form-item>

                                        <a-form-item label="理由" v-if="record.deleteType == 1" required>
                                            <a-input v-model:value="record.desc" placeholder="请输入理由"> </a-input>
                                        </a-form-item>
                                        <a-form-item label="理由" v-else>
                                            <a-input v-model:value="record.desc" placeholder="请输入理由"> </a-input>
                                        </a-form-item>
                                        <a-form-item label="备注"> 删除后可在主体回收站中撤回删除 </a-form-item>
                                    </a-form>
                                </template>
                                <a>删除</a>
                            </a-popconfirm>
                        </div>
                    </template>
                    <template v-if="column.dataIndex === '话术'">
                        <div class="tipsa">
                            <a-button @click="getallxflist(record, record.xftel)">话术1（全面版）</a-button>
                        </div>
                        <div class="tipsa">
                            <a-tooltip placement="top" color="#fff" :arrowPointAtCenter="true"
                                overlayClassName="custom-tooltip-width">
                                <template #title>
                                    <p style="color: #000; padding: 20px" v-html="record.hs1_show"></p>
                                </template>
                                <a-button @click="handleCopyClick2(record.hs1_copy, record)">话术1（简版）</a-button>
                            </a-tooltip>
                        </div>
                        <div class="tipsa">
                            <a-tooltip placement="top" color="#fff" :arrowPointAtCenter="true"
                                overlayClassName="custom-tooltip-width">
                                <template #title>
                                    <p style="color: #000; padding: 20px" v-html="record.hs2_show"></p>
                                </template>
                                <a-button @click="handleCopyClick2(record.hs2_copy, record)">话术2</a-button>
                            </a-tooltip>
                        </div>
                        <div class="tipsa" v-if="record.hs3_copy">
                            <a-tooltip placement="top" color="#fff" :arrowPointAtCenter="true"
                                overlayClassName="custom-tooltip-width">
                                <template #title>
                                    <p style="color: #000; padding: 20px" v-html="record.hs3_show"></p>
                                </template>
                                <a-button @click="handleCopyClick2(record.hs3_copy, record)">话术3</a-button>
                            </a-tooltip>
                        </div>
                    </template>
                    <template v-if="column.dataIndex === 'full_address_number'">
                        <div>{{ text }}</div>
                        <div
                            v-if="record.exception_flag == 2 || record.exception_flag == 3 || record.exception_flag == 4">
                            <a-popconfirm ok-text="确定" cancel-text="取消" :ok-button-props="{ size: 'middle' }"
                                :cancel-button-props="{ size: 'middle' }" title="待申报地址异常，确定提交申报吗？" placement="top"
                                @openChange="
                                    (e) => {
                                    }
                                " @confirm="change_exception_seller(record)" v-if="record.exception_flag == 2">
                                <template #description>
                                    <a-form style="width: 600px; margin-top: 30px" v-bind="formLayout"
                                        ref="attrformRef">
                                        <a-form-item :labelCol="{ span: 3 }" :wrapperCol="{ span: 17 }" label="备注"
                                            required name="remark">
                                            <a-input v-model:value="data.exception_remark" placeholder="申报理由"></a-input>
                                        </a-form-item>
                                        <a-form-item :labelCol="{ span: 3 }" :wrapperCol="{ span: 17 }" label="附件(选填)"
                                            name="exception_url">
                                            <Upload :upload_path="record.upload_path + '申报异常/'" uploadType="text"
                                                :accept="['pdf', 'doc', 'docx', 'xls', 'xlsx', 'jpeg', 'jpg', 'png']"
                                                :limitation="3" v-model:value="data.exception_url" uploadText="上传附件">
                                            </Upload>
                                        </a-form-item>
                                    </a-form>
                                </template>
                                <a-row>
                                    <a-col :span="24">
                                        <a-statistic-countdown title="代理商确定待申报异常倒计时"
                                            :value="record.exception_flag_seller_endtime * 1000"
                                            format="HH:mm:ss:SSS" />
                                    </a-col>
                                    <a-col :span="24"><a-button type="primary" size="small" danger>代理商点击即确认申报</a-button>
                                    </a-col>
                                </a-row>
                            </a-popconfirm>
                            <a-popconfirm ok-text="确定" cancel-text="取消" :ok-button-props="{ size: 'middle' }"
                                :cancel-button-props="{ size: 'middle' }" title="待申报地址异常，确定客户不配合吗？" placement="top"
                                @openChange="
                                    (e) => {
                                    }
                                " @confirm="change_exception_fws(record)"
                                v-if="data.user_permission == 'admin' || data.user_permission == 'platform'">
                                <template #description>
                                    <a-form style="width: 600px; margin-top: 30px" v-bind="formLayout"
                                        ref="attrformRef">
                                        <a-form-item :labelCol="{ span: 3 }" :wrapperCol="{ span: 17 }" label="备注"
                                            required name="remark">
                                            <a-input v-model:value="data.exception_remark" placeholder="申报理由"></a-input>
                                        </a-form-item>
                                        <a-form-item :labelCol="{ span: 3 }" :wrapperCol="{ span: 17 }" label="附件(选填)"
                                            name="exception_url">
                                            <Upload :upload_path="record.upload_path + '申报异常/'" uploadType="text"
                                                :accept="['pdf', 'doc', 'docx', 'xls', 'xlsx', 'jpeg', 'jpg', 'png']"
                                                :limitation="3" v-model:value="data.exception_url" uploadText="上传附件">
                                            </Upload>
                                        </a-form-item>
                                    </a-form>
                                </template>
                                <a-button type="primary" size="small" danger
                                    v-if="record.exception_flag == 3">平台人员点击即确认申报</a-button>
                            </a-popconfirm>
                        </div>
                        <a-row v-hasRole="['root', 'platform', 'seller']">
                            <a-col :span="6">
                                备注：
                            </a-col>
                            <a-col :span="18">
                                <div v-if="!record.remarkEdit">
                                    <a-tag color="red" class="pointer" v-if="record.common_remark">{{
                                        record.common_remark
                                        }}</a-tag>
                                    <a class="ml-1x" @click="() => {
                                        record.remark_new = record.common_remark
                                        record.remarkEdit = true
                                    }">
                                        <EditTwoTone />
                                    </a>
                                    <a class="ml-1x" @click="() => {
                                        record.remark_new = ''; editRemark(record)
                                    }">
                                        <DeleteTwoTone />
                                    </a>
                                </div>
                                <div v-if="record.remarkEdit">
                                    <a-input style=" margin-bottom: 5px" v-model:value="record.remark_new" name="remark"
                                        placeholder="请输入"></a-input>
                                    <div>
                                        <a-button class="mr-2x" @click="
                                            () => {
                                                record.remarkEdit = false
                                            }
                                        " size="small">取消</a-button>
                                        <a-button @click="editRemark(record)" size="small" type="primary">确认</a-button>
                                    </div>
                                </div>
                            </a-col>
                        </a-row>
                    </template>
                    <template v-if="column.dataIndex === 'seller'">
                        <div v-hasUser="[record.seller_id, record.ludan_id]">
                            <p class="mb-x">代理商：{{ record.seller ? record.seller : '-' }}</p>
                            <p class="mb-x">
                                <a-popover placement="left" :overlayInnerStyle="{
                                    padding: '25px'
                                }">
                                    <template #content>
                                        <div
                                            style="font-size: 16px; font-weight: 550; border-bottom: 1px dotted #ccc; padding-bottom: 8px">
                                            渠道详细情况：</div>
                                        <div style="width: 450px; line-height: 26px">
                                            <a-row>
                                                <a-col :span="10" style="text-align: right">工商预留手机号码：</a-col>
                                                <a-col :span="14">{{ record.registration_mobile }}<a
                                                        @click="handleCopyClick(record.registration_mobile)"
                                                        class="ml-1x">
                                                        <CopyOutlined />
                                                    </a></a-col>
                                            </a-row>
                                            <a-row>
                                                <a-col :span="10" style="text-align: right">续费联系人手机号码：</a-col>
                                                <a-col :span="14">{{ record.xftel }}<a
                                                        @click="handleCopyClick(record.xftel)" class="ml-1x">
                                                        <CopyOutlined />
                                                    </a></a-col>
                                            </a-row>
                                            <a-row>
                                                <a-col :span="10" style="text-align: right">财务公司名称：</a-col>
                                                <a-col :span="14">{{ record.finance_company_name }}</a-col>
                                            </a-row>
                                            <a-row>
                                                <a-col :span="10" style="text-align: right">财务公司统一社会信用代码：</a-col>
                                                <a-col :span="14">{{ record.finance_social_credit_code }}</a-col>
                                            </a-row>
                                            <a-row>
                                                <a-col :span="10" style="text-align: right">财务公司对接人姓名：</a-col>
                                                <a-col :span="14">{{ record.finance_contact_name }}</a-col>
                                            </a-row>
                                            <a-row>
                                                <a-col :span="10" style="text-align: right">财务公司对接人其他号码：</a-col>
                                                <a-col :span="14">{{ record.finance_contact_phone }}</a-col>
                                            </a-row>
                                            <a-row>
                                                <a-col :span="10" style="text-align: right">财务公司对接人微信昵称：</a-col>
                                                <a-col :span="14"><a-avatar size="small"
                                                        :src="record.xf_person?.headimgurl"
                                                        v-if="!!record.finance_contact_wechat_nickname">
                                                        <template #icon>
                                                            <UserOutlined />
                                                        </template> </a-avatar>{{
                                                            record.finance_contact_wechat_nickname }}</a-col>
                                            </a-row>
                                            <a-row>
                                                <a-col :span="10" style="text-align: right">财务公司对接人微信号：</a-col>
                                                <a-col :span="14">{{ record.finance_contact_wechat_account
                                                    }}<a v-if="!!record.finance_contact_wechat_account"
                                                        @click="handleCopyClick(record.finance_contact_wechat_account)"
                                                        class="ml-1x">
                                                        <CopyOutlined />
                                                    </a></a-col>
                                            </a-row>
                                            <a-row>
                                                <a-col :span="10" style="text-align: right">备注：</a-col>
                                                <a-col :span="14">{{ record.remark }}</a-col>
                                            </a-row>
                                        </div>
                                    </template>
                                    续费人： <a-avatar size="small" :src="record.xf_person?.headimgurl">
                                        <template #icon>
                                            <UserOutlined />
                                        </template>
                                    </a-avatar>
                                </a-popover>
                                {{ record.xf_person?.nickname }}
                                <span v-if="record.xf_person">
                                    <a type="primary" style="margin-left: 10px" @click="onViewLogClick(record, 4)"> 发消息
                                    </a>
                                </span>
                                <span v-else>该续费联系人未关注公众号，无法快捷发送消息！先关注公众号<a-image :width="20"
                                        src="https://hncs.cskaiyela.com/wxewm.jpg" /></span>
                            </p>
                        </div>
                        <span>{{ record.created_at }}</span><a @click="handleCopyClick(record.xftel)" class="ml-1x"
                            v-hasUser="[record.seller_id, record.ludan_id]">
                            <CopyOutlined />
                        </a>
                    </template>
                    <template v-if="column.dataIndex === 'action'">
                        <div class="mb-x">
                            <a-popover @openChange="
                                (val) => {
                                    optionsVisibleChange(val, record)
                                }
                            " trigger="click" v-model:open="record.isShowOptions"
                                overlayClassName="customer-options-popover">
                                <template #content>
                                    <p @click="onActionClick(record, 'AddTable')">标签管理</p>
                                    <p @click="onCopyClick(record)" v-if="record.permission_show_edit == 1">复制</p>
                                    <a-popconfirm title="确定申报地址异常?" placement="left" @openChange="
                                        (e) => {
                                            openDeleteChange(e, record)
                                        }
                                    " @confirm="listed_in_anomaly(record)" ok-text="确定" cancel-text="取消"
                                        :ok-button-props="{ size: 'middle' }" :cancel-button-props="{ size: 'middle' }">
                                        <template #description>
                                            <a-form style="width: 600px; margin-top: 30px" v-bind="formLayout">
                                                <a-form-item label="申报地址异常理由" style="width: 800px" required>
                                                    <a-input v-model:value="record.anomaly_desc" placeholder="请输入理由"
                                                        style="width: 320px"> </a-input>
                                                </a-form-item>

                                                <a-form-item :labelCol="{ span: 5 }" :wrapperCol="{ span: 19 }"
                                                    label="失联的短信电话截图" style="width: 800px" required labelWrap="true">
                                                    <Upload :upload_path="record.upload_path"
                                                        :accept="['png', 'jpg', 'jpeg', 'pdf']"
                                                        uploadType="picture-card" :limitation="99"
                                                        :customerName="record.full_name"
                                                        v-model:value="record.anomaly_url" uploadText="上传失联的短信、电话截图">
                                                    </Upload>
                                                </a-form-item>
                                                <a-form-item label="操作" :labelCol="{ span: 5 }"
                                                    :wrapperCol="{ span: 19 }" style="width: 800px">
                                                    <a-radio-group v-model:value="record.doaction_type">
                                                        <a-radio :value="1" checked="checked"> 直接列入 </a-radio>
                                                        <a-radio :value="2"> 仅下载列入异常申报资料 </a-radio>
                                                    </a-radio-group>
                                                </a-form-item>
                                                <a-form-item :labelCol="{ span: 5 }" :wrapperCol="{ span: 19 }"
                                                    label="备注" style="width: 800px">
                                                    <a-input v-model:value="record.anomaly_remark"
                                                        placeholder="请输入备注（可填）" style="width: 320px"> </a-input>
                                                </a-form-item>
                                                <a-form-item style="width: 800px">
                                                    提示：申报地址异常后还需要递交资料才可以正式列入，请知悉！确定后将自动生成列入异常模板，也可前往档案管理里面再次下载！
                                                </a-form-item>
                                            </a-form>
                                        </template>
                                        <p>申报地址异常</p>
                                    </a-popconfirm>
                                    <a-popconfirm title="确定删除?" placement="left" @openChange="
                                        (e) => {
                                            openDeleteChange(e, record)
                                        }
                                    " @confirm="handleDelete(record)">
                                        <template #description>
                                            <a-form style="width: 600px" v-bind="formLayout">
                                                <a-form-item label="删除原因" required>
                                                    <a-radio-group v-model:value="record.deleteType">
                                                        <a-radio :value="1">废弃</a-radio>
                                                        <a-radio :value="2">该主体已注销</a-radio>
                                                        <a-radio :value="3">该主体已迁出</a-radio>
                                                    </a-radio-group>
                                                </a-form-item>

                                                <a-form-item label="理由" v-if="record.deleteType == 1" required>
                                                    <a-input v-model:value="record.desc" placeholder="请输入理由"> </a-input>
                                                </a-form-item>
                                                <a-form-item label="理由" v-else>
                                                    <a-input v-model:value="record.desc" placeholder="请输入理由"> </a-input>
                                                </a-form-item>
                                                <a-form-item label="备注"> 删除后可在主体回收站中撤回删除 </a-form-item>
                                            </a-form>
                                        </template>
                                        <p>删除</p>
                                    </a-popconfirm>
                                    <p v-if="record.is_pay != 2 && record.fee_standard != 2"
                                        @click="onActionClick(record, 'PayCenter')">地址续费</p>
                                    <!-- <p @click="onActionClick(record, 'EntryAgreement')">入驻协议快照</p> -->
                                    <p @click="onActionClick(record, 'SFMail')" v-if="record.permission_show_edit == 1">
                                        顺丰邮寄</p>
                                    <p @click="onPushPaymentClick(record)">推送至微信收款</p>
                                    <p v-if="!record.first_pay_time" @click="onDirectPaymentClick(record)">支付第一次入驻服务费
                                    </p>
                                    <p @click="onPlatformClick(record)">平台充值</p>
                                    <a-popover trigger="click" overlayClassName="customer-options-popover">
                                        <template #content>
                                            <p @click="onTaxInquiryClick(record, 1)">税务基础情况查询</p>
                                            <p @click="onTaxInquiryClick(record, 2)">一般纳税人查询</p>
                                            <p @click="onTaxInquiryClick(record, 3)">税务登记基本信息查询</p>
                                        </template>
                                        <p>税务查询</p>
                                    </a-popover>
                                    <p @click="onActionClick(record, 'Refund')" v-if="record.permission_show_edit == 1">
                                        退款</p>
                                </template>
                                <a @click="
                                    () => {
                                        record.isShowOptions = true
                                    }
                                ">更多操作</a> </a-popover><a-divider type="vertical" /> <a
                                @click="onActionClick(record, 'Record')">档案管理</a>
                            <a-divider type="vertical" />
                            <a @click="handleEdit(record)" v-if="record.permission_show_edit == 1">编辑</a>
                        </div>
                        <a-popover trigger="click" overlayClassName="customer-options-popover">
                            <template #content>
                                <div v-for="(item, index) in record.DownType" :key="index" @click="downLease(item)">
                                    <a-popover trigger="click" overlayClassName="customer-options-popover"
                                        v-if="item.children?.length > 0">
                                        <template #content>
                                            <div v-for="(downLeaseItem, downLeaseIndex) in item.children"
                                                :key="downLeaseIndex" @click="downLease(downLeaseItem)">
                                                <div v-if="downLeaseItem.children?.length > 0">
                                                    {{ downLeaseItem.name }}
                                                </div>
                                                <p v-else>
                                                    {{ downLeaseItem.name }}
                                                </p>
                                                <div v-if="downLeaseItem.children?.length > 0">
                                                    <p v-for="(downItem, downIndex) in downLeaseItem.children"
                                                        :key="downIndex" @click="downLease(downItem)">
                                                        {{ downItem.name }}
                                                    </p>
                                                </div>
                                            </div>
                                        </template>
                                        <p>{{ item.name }}</p>
                                    </a-popover>
                                    <p v-else>{{ item.name }}</p>
                                </div>
                            </template>

                            <a v-if="data.tabsExceptionKey == 2">下载申报异常材料</a>
                        </a-popover>
                        <a-badge-ribbon text="已确认，可以申报异常了" color="pink"
                            v-if="record.exception_flag == 4"></a-badge-ribbon>
                    </template>
                </template>
            </a-table>
            <a-modal v-model:open="data.cuikuanbox" :title="data.cuikuanbox_title" @ok="
                () => {
                    data.cuikuanbox = false
                }
            " style="width: 50%">
                <a-table :pagination="false" :dataSource="data.cuikuan_data" :columns="[
                    {
                        title: '序号',
                        dataIndex: 'index',
                        key: 'index',
                        width: 60
                    },
                    {
                        title: '催款时间',
                        dataIndex: 'created_at',
                        key: 'created_at'
                    },
                    {
                        title: '催款人',
                        dataIndex: 'author',
                        key: 'author'
                    }
                ]">
                    <template #bodyCell="{ column, record, index, text }">
                        <template v-if="column.dataIndex === 'index'"> {{ index + 1 }} </template>
                        <template v-if="column.dataIndex === 'name'"> {{ text }} {{ record.phone_number }} </template>
                        <template v-if="column.dataIndex === 'enter_endtime'"> <span
                                v-html="record.enter_endtime2"></span></template>
                    </template>
                </a-table>
            </a-modal>
            <!-- 续费联系人的所有续费名单 -->
            <ContactXf v-if="data.contactxfVisible" :detailData="data.contactxfDetailData"
                :user_permission="data.user_permission" @cancel="data.contactxfVisible = false"></ContactXf>
            <!-- 新增客户 -->
            <edit-form v-if="data.editVisible" :open="true" :tableColumnsData="data.tableColumnsData"
                @cancel="handleCancel" @ok="handleOk" />
            <CopyForm v-if="data.copyVisible" :open="true" :tableColumnsData="data.tableColumnsData"
                @cancel="handleCancel" @ok="handleOk" />
            <Refund v-if="data.refundVisible" :tableColumnsData="data.tableColumnsData" @cancel="handleCancel"
                @ok="handleOk" />

            <!-- 直接付款 -->
            <direct-payment v-if="data.directPaymentVisible" @cancel="handleCancel" @ok="handleOk"
                :tableColumnsData="data.tableColumnsData"></direct-payment>
            <PlatformBalanceCharge v-if="data.platformVisible" @cancel="handleCancel" @ok="handleOk"
                :customerPlatformId="data.tableColumnsData.platform_id" :bussType="1">
            </PlatformBalanceCharge>

            <s-f-mail :tableColumnsData="data.tableColumnsData" v-if="data.SFMailVisible" @cancel="handleCancel"
                @ok="handleOk"></s-f-mail>
            <PayCenter :tableColumnsData="data.tableColumnsData" v-if="data.addressRenewVisible" @cancel="handleCancel"
                @ok="handleOk"></PayCenter>
            <AddLabel :tableColumnsData="data.tableColumnsData" v-if="data.addTableVisible" @cancel="
                () => {
                    data.addTableVisible = false
                }
            "></AddLabel>
            <Record :tableColumnsData="data.tableColumnsData" v-if="data.recordVisible" @cancel="
                () => {
                    data.recordVisible = false
                }
            "></Record>
        </div>
        <ExceptionTaizhang v-if="data.showtype == 2" ref="taizhangRef" :queryParam="queryParam"></ExceptionTaizhang>
        <!-- 查看日志 -->
        <view-log :logTabsKey="data.logTabsKey" v-if="data.visibleLog" :tableColumnsData="data.tableColumnsData"
            @cancel="viewLogCancel"></view-log>
        <!-- 发送微信催款的确认弹窗 -->
        <a-modal v-model:open="data.confirmSendWechat" title="确认发送微信催款" @ok="sendCuikuanDo" width="40%">
            <p>{{ data.confirmSendWechatInfo }}</p>
            <p>请确保发财人客户端在线，并已登录微信。</p>
            <!-- ===== 新增：催款模板选择 ===== -->
            <a-form layout="inline" style="margin-top: 16px;">
                <a-form-item label="催款模板" style="flex:1;">
                    <a-select v-model:value="data.selectedTemplateId" placeholder="请选择催款模板" style="width: 400px;"
                        allow-clear :loading="data.templateLoading">
                        <a-select-option v-for="tpl in data.templateList" :key="tpl.id" :value="tpl.id">
                            {{ tpl.name }}
                        </a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item>
                    <a-button type="primary" @click="openAddTemplateModal"
                        :disabled="data.templateLoading">新增</a-button>
                    <a-button type="danger" style="margin-left:8px;" @click="deleteSelectedTemplate"
                        :disabled="!data.selectedTemplateId || data.templateDeleting">删除</a-button>
                    <a-button type="primary" @click="openEditTemplateModal" v-if="selectedTemplate"
                        :disabled="data.templateLoading">编辑</a-button>
                </a-form-item>
            </a-form>
            <!-- ===== 新增：模板预览区域 ===== -->
            <div v-if="selectedTemplate"
                style="margin-top:12px; padding:12px; border:1px solid #d9d9d9; border-radius:4px; background:#fafafa; white-space:pre-wrap; max-height:200px; overflow-y:auto;">
                {{ selectedTemplate.content }}
            </div>
            <div v-else style="margin-top:12px; color:#999; font-size:13px;">请选择模板以预览内容</div>
            <p>示例:<br /><span
                    v-text="'老板您好，地址挂靠主体：{{customer.full_name}}要续费了, 法人：{{fddbr_name}} {{fddbr_phone}} 到期时间：{{rz_enddate}} {{rz_address}} 当前状态：{{curstatus}}'"></span>
            </p>
        </a-modal>
        <!-- ===== 新增：新增模板 Modal ===== -->
        <a-modal v-model:open="data.templateModalVisible" title="新增催款模板" @ok="handleCreateTemplate"
            @cancel="closeTemplateModal" :confirmLoading="data.templateCreating" :maskClosable="false" width="40%">
            <a-form :model="data" layout="vertical">
                <a-form-item label="模板名称" required>
                    <a-input v-model:value="data.newTemplateName" placeholder="请输入模板名称" />
                </a-form-item>
                <a-form-item label="模板内容" required>
                    <a-textarea v-model:value="data.newTemplateContent" placeholder="请输入催款内容" :rows="6" />
                    <p>示例:<br /><span
                            v-text="'老板您好，地址挂靠主体：{{customer.full_name}}要续费了, 法人：{{fddbr_name}} {{fddbr_phone}} 到期时间：{{rz_enddate}} {{rz_address}} 当前状态：{{curstatus}}'"></span>
                    </p>
                </a-form-item>
            </a-form>
        </a-modal>
    </a-card>
</template>

<script lang="ts" setup name="CustomerList">
import { UserOutlined } from '@ant-design/icons-vue'
import SvgIcon from '@/components/SvgIcon/index.vue'
import { PlusOutlined, DownOutlined, UpOutlined, EditTwoTone, DeleteTwoTone, CopyOutlined } from '@ant-design/icons-vue'
import type { PaginationProps } from 'ant-design-vue'
import CopyForm from './CreateForm.vue'
import EditForm from './CreateForm.vue'
import Refund from './components/Refund.vue'
import Record from './components/Record.vue'
import Upload from '@/components/base/Upload.vue'
import ViewLog from './components/ViewLog.vue'
import ExceptionTaizhang from './components/ExceptionTaizhang.vue'
import PayCenter from './components/PayCenter.vue'
import DirectPayment from './components/DirectPayment.vue'
import PlatformBalanceCharge from './../financialManagement/components/PlatformBalanceCharge.vue'
import SFMail from './components/SFMail.vue'
import AddLabel from './components/addLabel.vue'
import ContactXf from './components/ContactXf.vue'
import ChangeExceptionflag from './components/ChangeExceptionflag.vue'
import { useRouter } from 'vue-router'
import { message, Modal, Table } from 'ant-design-vue'
import baseService from '@/utils/http/axios'
import { unref, ref, reactive, h, onMounted, computed, onActivated, nextTick, watch } from 'vue'
import dayjs from 'dayjs'
import ls from '@/utils/Storage'
const arrayMonent = [dayjs('00:00:00', 'HH:mm:ss'), dayjs('23:59:59', 'HH:mm:ss')]
const token = ls.get('ACCESS_TOKEN').replace('Bearer ', '')
const user = ls.get('USER_INFO')
import { useStore } from 'vuex'
const $store = useStore()
const router = useRouter()
const format = 'YYYY-MM-DD HH:mm:ss'
const taizhangRef = ref()

const shareholderColumns: Object[] = [
    {
        title: '姓名、手机号码',
        dataIndex: 'name'
    },
    {
        title: '身份证号码',
        dataIndex: 'id_card_number'
    },
    {
        title: '职位',
        dataIndex: 'position_name'
    },
    {
        title: '出资金额',
        dataIndex: 'investment_money'
    },
    {
        title: '认缴出资日期',
        dataIndex: 'subscribe_endtime'
    }
]

const data = reactive({
    key: '',
    rowSelection: [],
    customerNavig: {},
    exportLoading: false,
    // 入驻协议
    entryAgreementVisible: false,
    // 档案管理
    recordVisible: false,
    // 打标签
    addTableVisible: false,
    // 查看签名状态
    signatureStatusVisible: false,
    // 付款弹窗
    directPaymentVisible: false,
    platformVisible: false,
    // 推送付款
    pushPaymentVisible: false,

    // 顺丰邮寄
    SFMailVisible: false,
    //   地址续费
    addressRenewVisible: false,
    visibleLog: false,
    visibleStatus: false,
    // 操作弹窗
    optionsVisible: false,
    // create model
    visible: false,
    // 高级搜索 展开/关闭
    advanced: true,
    tableColumnsData: {},
    loading: false,
    // 编辑
    editVisible: false,
    copyVisible: false,
    refundVisible: false,
    // 进入日志 还是进入状态
    logTabsKey: 1,
    createKey: 1,
    platformList: [],
    /* 下载列表 */
    downList: {},
    //数据列表
    customerInfo: {},
    // 进度状态
    progressOptions: [],
    tabsKey: 2,
    tabsExceptionKey: 1,
    showtype: 1,
    chat_read_count: 0,
    contactxfVisible: false,
    contactxfDetailData: {},
    tips: '',
    cuikuanbox: false,
    taizhangdata: [],
    cuikuanbox_title: '',
    cuikuan_data: '',
    cuikuanLoading: false,
    confirmSendWechat: false,
    confirmSendWechatInfo: '',
    exception_flag_disabled: false,
    download_sbException_loading: false,
    user_permission: 'shixi', //用户权限admin,platform,seller,shixi实习代理商
    exception_remark: '',
    exception_url: [],
    // ===== 新增：模板管理 =====
    templateList: [],
    selectedTemplateId: undefined,
    templateModalVisible: false,
    newTemplateId: null,
    newTemplateName: '',
    newTemplateContent: '',
    templateLoading: false,
    templateDeleting: false,
    templateCreating: false,
})
const filteredInfo = ref()

// ===== 计算属性：获取当前选中的模板对象 =====
const selectedTemplate = computed(() => {
    return data.templateList.find(tpl => tpl.id === data.selectedTemplateId) || null
})

const columns = computed(() => {
    const filtered = filteredInfo.value || []
    const progressOptions = data.progressOptions
    return [
        {
            title: '公司名称',
            dataIndex: 'companyInformation',
            width: 350
        },

        {
            title: '到期时间',
            dataIndex: 'enter_endtime',
            filters: progressOptions,
            filteredValue: filtered || null,
            width: 280
        },
        {
            title: '话术',
            dataIndex: '话术',
            width: 180
        },
        {
            title: '地址',
            dataIndex: 'full_address_number',
            width: 200
        },
        {
            title: '其他信息',
            dataIndex: 'seller',
            width: 200
        },
        {
            title: '操作',
            dataIndex: 'action',
            width: 200
        }
    ]
})
const formLayout = {
    labelCol: {
        xs: { span: 4 },
        sm: { span: 4 }
    },
    wrapperCol: {
        xs: { span: 16 },
        sm: { span: 16 }
    }
}
let queryParam = reactive<any>({
    order_status_list: [],
    fee_standard: [1],
    exception_flag: [1, 2, 3, 4]
})
let dataSource = ref([])
const pagination = reactive<PaginationProps>({
    pageSize: 10,
    pageSizeOptions: ['10', '20', '40', '50', '60', '100', '200', '500'],
    current: 1,
    total: undefined,
    showSizeChanger: true,
    showQuickJumper: true,
    showTotal: (total) => `总数：${total}`
})
onMounted(() => {
    platformList()
    customerNavig()
    loadData()
})
onActivated(() => {
    queryParam.nameOrCode = router.currentRoute.value.query.customer_name
    if (router.currentRoute?.value?.query?.customer_name) {
        loadData()
    }
})

// ===== 监听 confirmSendWechat 打开时加载模板列表 =====
watch(
    () => data.confirmSendWechat,
    (newVal) => {
        if (newVal) {
            loadTemplateList()
        }
    }
)

// ===== 模板管理相关方法 =====
const loadTemplateList = () => {
    data.templateLoading = true
    const requestParam = {
        url: '/admin/v1/cuikuantemplate/mylist',
        method: 'get',
    }
    baseService(requestParam)
        .then((res) => {
            data.templateList = res.data || []
            // 默认选中第一个（如果当前没有选中或选中的已不存在）
            if (data.templateList.length > 0) {
                const exists = data.templateList.some(t => t.id === data.selectedTemplateId)
                if (!data.selectedTemplateId || !exists) {
                    data.selectedTemplateId = data.templateList[0].id
                }
            } else {
                data.selectedTemplateId = undefined
            }
        })
        .catch((err) => {
            message.error(err.msg || '加载模板列表失败')
        })
        .finally(() => {
            data.templateLoading = false
        })
}

const openAddTemplateModal = () => {
    data.newTemplateId = null
    data.newTemplateName = ''
    data.newTemplateContent = ''
    data.templateModalVisible = true
}
const openEditTemplateModal = () => {
    if (selectedTemplate.value) {
        data.newTemplateId = selectedTemplate.value.id
        data.newTemplateName = selectedTemplate.value.name
        data.newTemplateContent = selectedTemplate.value.content
        data.templateModalVisible = true
    }
}
const closeTemplateModal = () => {
    data.templateModalVisible = false
}

const handleCreateTemplate = () => {
    if (!data.newTemplateName.trim()) {
        message.warn('请输入模板名称')
        return
    }
    if (!data.newTemplateContent.trim()) {
        message.warn('请输入模板内容')
        return
    }
    data.templateCreating = true
    if (data.newTemplateId > 0) {
        const requestParam = {
            url: '/admin/v1/cuikuantemplate/' + data.newTemplateId,
            method: 'put',
            data: {
                name: data.newTemplateName.trim(),
                content: data.newTemplateContent.trim(),
            },
        }
        baseService(requestParam)
            .then((res) => {
                message.success(res.msg || '修改模板成功')
                data.templateModalVisible = false
                // 刷新列表并自动选中新建的模板（loadTemplateList 会自动选第一个）
                loadTemplateList()
            })
            .catch((err) => {
                message.error(err.msg || '修改模板失败')
            })
            .finally(() => {
                data.templateCreating = false
            })
    } else {
        const requestParam = {
            url: '/admin/v1/cuikuantemplate',
            method: 'post',
            data: {
                name: data.newTemplateName.trim(),
                content: data.newTemplateContent.trim(),
            },
        }
        baseService(requestParam)
            .then((res) => {
                message.success(res.msg || '新增模板成功')
                data.templateModalVisible = false
                // 刷新列表并自动选中新建的模板（loadTemplateList 会自动选第一个）
                loadTemplateList()
            })
            .catch((err) => {
                message.error(err.msg || '新增模板失败')
            })
            .finally(() => {
                data.templateCreating = false
            })
    }
}

const deleteSelectedTemplate = () => {
    if (!data.selectedTemplateId) {
        message.warn('请先选择一个模板')
        return
    }
    Modal.confirm({
        title: '确认删除',
        content: '确定要删除该催款模板吗？',
        okText: '删除',
        cancelText: '取消',
        onOk: () => {
            data.templateDeleting = true
            const requestParam = {
                url: '/admin/v1/cuikuantemplate/' + data.selectedTemplateId,
                method: 'delete'
            }
            baseService(requestParam)
                .then((res) => {
                    message.success(res.msg || '删除成功')
                    data.selectedTemplateId = undefined
                    loadTemplateList()
                })
                .catch((err) => {
                    message.error(err.msg || '删除模板失败')
                })
                .finally(() => {
                    data.templateDeleting = false
                })
        },
    })
}

// 以下为原有方法，保持不变
// 跳转天眼查
const handleDoubleNameClick = (url) => {
    window.open(url)
}
// 时间选择
const rangTime = computed(() => {
    let array: any = []
    if (queryParam.between_time) {
        array = queryParam.between_time.split(',').map((item) => dayjs(item ? item : null, format))
    } else {
        array = []
    }
    return array
})
// 时间选择
const rangTimeChange = (val, str) => {
    if (val) {
        queryParam.between_time = str.join(',')
    } else {
        queryParam.between_time = null
    }
}
const rangEnd = computed(() => {
    let array: any = []
    if (queryParam.between_end) {
        array = queryParam.between_end.split(',').map((item) => dayjs(item ? item : null, format))
    } else {
        array = []
    }
    return array
})
// 时间选择
const rangEndChange = (val, str) => {
    if (val) {
        queryParam.between_end = str.join(',')
    } else {
        queryParam.between_end = null
    }
}

// 复制
const handleCopyClick = (val) => {
    if (!val) {
        message.error('手机号不存在')
        return
    }
    var input = document.createElement('textarea')
    //将input的值设置为需要复制的内容
    eval('input.value' + '="' + val + '"')
    //添加input标签
    document.body.appendChild(input)
    //选中input标签
    input.select()
    //执行复制
    document.execCommand('copy')
    //成功提示信息
    message.success('复制成功!')
    //移除input标签
    document.body.removeChild(input)
}
//复制该续费联系人的所有待续费名单
const handleCopyClick2 = (val, record) => {
    // 获取到列表数据
    let requestParam = {
        url: '/admin/v1/copyhuashu',
        method: 'post',
        data: {
            customer_id: record.id
        }
    }
    baseService(requestParam)
        .then((res: any) => {
            if (res.code == 200) {
                navigator.clipboard.writeText(val)
                record.lastcuikuanlog = res.data['tips']
                message.success(res.msg ? res.msg : '复制成功!')
            }
        })
        .catch((res) => {
            message.error(res.msg ? res.msg : '复制失败')
        })
}

// 复制名称
const handleNameClick = (e, name) => {
    if (e.detail == 1) {
        var input = document.createElement('input')
        //将input的值设置为需要复制的内容
        input.value = name
        //添加input标签
        document.body.appendChild(input)
        //选中input标签
        input.select()
        //执行复制
        document.execCommand('copy')
        //成功提示信息
        message.success('复制成功，尝试双击有惊喜！')
        //移除input标签
        document.body.removeChild(input)
    }
}
//展现催款日志
const showcuikuanlog = (record) => {
    data.cuikuanbox = true
    data.cuikuanbox_title = record.full_name + '的催款日志'
    let requestParam = {
        url: '/admin/v1/cuikuanlog',
        method: 'post',
        data: {
            customer_id: record.id
        }
    }
    baseService(requestParam)
        .then((res: any) => {
            if (res.code == 200) {
                data.cuikuan_data = res.data
            }
        })
        .catch((res) => {
            message.error(res.msg ? res.msg : '查询失败')
        })
}
//查询续费联系人所有续费列表
const showContactxf = (customer_id, xftel) => {
    data.contactxfDetailData = {
        customer_id: customer_id,
        xftel: xftel
    }
    data.contactxfVisible = true
}
//复制该续费联系人的所有待续费名单
const getallxflist = (record, xftel) => {
    // 获取到列表数据
    let requestParam = {
        url: '/admin/v1/getallxflist',
        method: 'post',
        data: {
            customer_id: record.customer_id,
            xftel: xftel,
            type: 1
        }
    }
    baseService(requestParam)
        .then((res: any) => {
            if (res.code == 200) {
                let clipboardvalue = ''
                // eval('clipboardvalue' + '="' + res.data.msg + '"')
                clipboardvalue = res.data.msg
                navigator.clipboard.writeText(clipboardvalue)
                record.lastcuikuanlog = res.data[0]['tips']
                message.success(res.msg ? res.msg : '复制成功!')
            }
        })
        .catch((res) => {
            message.error(res.msg ? res.msg : '复制失败！')
        })
}
// 进度状态选择
const tabsExceptionKeyChange = (val) => {
    if (val != 1) {
        queryParam.exception_flag = [val]
        data.exception_flag_disabled = true
        if (val == 6) {
            //直接只显示台账
            data.showtype = 2
            loadtaizhang()
        } else {
            loadData()
        }
    } else {
        data.exception_flag_disabled = false
        queryParam.exception_flag = [1, 2, 3, 4]
        loadData()
    }
}
// 重置刷新
const refreshTabel = () => {
    pagination.current = 1
    filteredInfo.value = []
    data.tabsKey = 2
    let obj = Object.keys(queryParam).reduce((a, key) => ({ ...a, [key]: undefined }), {})
    Object.assign(queryParam, obj)
    loadData()
}
const formatDuration = (duration: number) => {
    const days: any = Math.floor(duration / (24 * 60 * 60))
    if (days > 0 && days <= 30) {
        return '到期前30天内'
    } else if (days > 30 && days <= 60) {
        return '到期前60天内'
    } else if (days < 0 && days >= -30) {
        return '到期后30天内'
    } else if (days < -30 && days >= -60) {
        return '到期后60天内'
    } else if (days < -60 && days >= -90) {
        return '到期后90天内'
    } else if (days < -90) {
        return '到期90天后客户,即将申报工商地址异常'
    } else {
        return null
    }
}
const enterTime = (endtime) => {
    const start = dayjs(endtime)
    const end = dayjs()
    const duration = start.diff(end, 'second')
    return formatDuration(duration)
}
// 获取台账数据
const loadtaizhang = () => {
    if (data.showtype == 1) {
        loadData()
        return
    } else {
        queryParam.showtype = 2
        //加载子组件数据
        nextTick(() => {
            taizhangRef.value.loadData()
        })
    }
}
// 列表数据
const loadData = () => {
    //   if (data.loading) {
    //     return
    //   }
    data.loading = true
    data.showtype = 1
    // 获取到列表数据
    let requestParam = {
        url: '/admin/v1/customerList',
        method: 'post',
        data: Object.assign({ page: pagination.current, limit: pagination.pageSize, type: 'xf' }, queryParam)
    }
    baseService(requestParam)
        .then((res) => {
            data.loading = false
            pagination.total = res.data.total_records
            data.customerInfo = {
                unrecorded_electronic: res.data.unrecorded_electronic,
                modify_data: res.data.modify_data,
                to_be_verified: res.data.to_be_verified
            }
            dataSource.value = res.data.list.map((item) => {
                if (queryParam.nameOrCode) {
                    item.fullName = item.full_name.replace(queryParam.nameOrCode, `<span style="color: red">${queryParam.nameOrCode}</span>`)
                } else {
                    item.fullName = item.full_name
                }
                return { ...item, isShowOptions: false, isShowCompany: false, desc: null, deleteType: null }
            })
            let downList: any = []
            for (const key in res.data.down_type) {
                downList.push({ type: key, name: res.data.down_type[key] })
            }
            if (data.progressOptions != res.data.order_status_list) {
                data.progressOptions = res.data.order_status_list
            }
            data.downList = downList
            data.user_permission = res.data.user_permission
        })
        .catch((res) => {
            data.loading = false
            if (res.msg) {
                message.error(res.msg)
            } else {
                message.error('客户列表查询失败,请联系管理员')
            }
        })
}
const customerNavig = () => {
    // 获取到列表数据
    let requestParam = {
        url: '/admin/v1/customerNavig',
        method: 'get'
    }
    baseService(requestParam)
        .then((res) => {
            Object.assign(data.customerNavig, res.data)
        })
        .catch((res) => {
            if (res.msg) {
                message.error(res.msg)
            } else {
                message.error('获取统计失败')
            }
        })
}
// 获取平台数据
const platformList = () => {
    // 获取到列表数据
    let requestParam = {
        url: '/admin/v1/platformList',
        method: 'post',
        data: { limit: 'all', 'haveOld': 1 }
    }
    baseService(requestParam)
        .then((res) => {
            data.platformList = res.data.list
        })
        .catch((res) => {
            if (res.msg) {
                message.error(res.msg)
            } else {
                message.error('平台列表查询失败,请联系管理员')
            }
        })
}
// 表格分页查询
const onChange = (val, filters) => {
    pagination.pageSize = val.pageSize
    pagination.current = val.current
    if (filters.status) {
        queryParam.order_status_list = filters.status
    }
    loadData()
}
const onActionClick = (record, type) => {
    record.isShowOptions = false
    data.tableColumnsData = { ...record }
    switch (type) {
        case 'EntryAgreement':
            data.entryAgreementVisible = true
            break
        case 'SignatureStatus':
            data.signatureStatusVisible = true
            break
        case 'Record':
            data.recordVisible = true
            break
        case 'AddTable':
            data.addTableVisible = true
            break
        case 'SFMail':
            data.SFMailVisible = true
            break
        case 'PayCenter':
            data.addressRenewVisible = true
            break
        case 'Refund':
            data.refundVisible = true
            break
    }
}
// 查询日志
const onViewLogClick = (record, val) => {
    record.from = 0
    data.visibleLog = true
    data.tableColumnsData = { ...record }
    data.logTabsKey = val
}

const onDirectPaymentClick = (record) => {
    record.isShowOptions = false
    data.directPaymentVisible = true
    data.tableColumnsData = { ...record }
}
const onPlatformClick = (record) => {
    record.isShowOptions = false
    data.platformVisible = true
    data.tableColumnsData = { ...record }
}
const onTaxInquiryClick = (record, type) => {
    let param = `?${record.social_credit_code ? 'data-creditcode=' + record.social_credit_code + '&' : ''}data-companyname=${record.full_name}&type=1`
    if (type == 1) {
        window.open('http://hunan.chinatax.gov.cn/taxpayerstatesearch/20190413003982' + param)
    } else if (type == 2) {
        window.open('http://hunan.chinatax.gov.cn/taxpayersearch/20190413003981' + param)
    } else if (type == 3) {
        window.open('http://hunan.chinatax.gov.cn/taxreginfosearch/20190413003984' + param)
    }
}
const handleEdit = (record) => {
    data.editVisible = true
    data.tableColumnsData = { ...record }
}
const onPushOrderMakingClick = (record) => {
    data.tableColumnsData = { ...record }
}

const onPushPaymentClick = (record) => {
    data.pushPaymentVisible = true
}

const optionsVisibleChange = (val, record) => {
    if (!val) {
        record.isShowOptions = false
    }
}
const openDeleteChange = (e, record) => {
    if (!e) {
        record.deleteType = null
        record.desc = null
    }
}
const listed_in_anomaly = (record) => {
    if (!record.anomaly_desc) {
        message.warn('请输入申报地址异常的理由')
        return new Promise((resolve, reject) => {
            reject()
        })
    }
    let requestParam = {
        url: '/admin/v1/listed_in_anomaly',
        method: 'post',
        data: { customer_id: record.id, desc: record.anomaly_desc, url: record.anomaly_url, remark: record.anomaly_remark }
    }
    baseService(requestParam)
        .then((res) => {
            record.exception_flag = [2]
            message.success({
                content: res.msg,
                duration: 10
            })
        })
        .catch((res) => {
            if (res.msg) {
                message.error(res.msg)
            } else {
                message.error('列入异常失败，请联系管理员')
            }
        })
}
//增加催款日志
const addcuikuanlog = (id) => {
    let requestParam = {
        url: '/admin/v1/addcuikuanlog',
        method: 'post',
        data: { customer_id: id }
    }
    baseService(requestParam)
        .then((res: any) => {
            data.tips = res.data.tips
            message.success(res.msg)
        })
        .catch((res) => {
            message.error(res.msg)
        })
}
const gettips = (id) => {
    let requestParam = {
        url: '/admin/v1/getnewcuikuanlog',
        method: 'post',
        data: { id: id }
    }
    baseService(requestParam)
        .then((res: any) => {
            return res.msg
        })
        .catch((res) => {
            message.error(res.msg)
        })
}
//得到地址异常日志
const getExceptionLog = (record, index) => {
    data.visibleLog = true
    record.from = 1
    data.tableColumnsData = { ...record }
    data.logTabsKey = index
}
const handleDelete = (record) => {
    if (!record.deleteType) {
        message.warn('请选择删除原因')
        return new Promise((resolve, reject) => {
            reject()
        })
    }
    if (record.deleteType == 1 && !record.desc && user.id != 1) {
        message.warn('请输入删除理由')
        return new Promise((resolve, reject) => {
            reject()
        })
    }
    return new Promise((resolve, reject) => {
        let requestParam = {
            url: '/admin/v1/customer/' + record.id,
            method: 'delete',
            data: {
                type: record.deleteType,
                reason: record.desc
            }
        }
        baseService(requestParam)
            .then((res: any) => {
                message.success(res.msg)
                loadData()
                resolve(true)
            })
            .catch((res) => {
                if (res.msg) {
                    message.error(res.msg)
                } else {
                    message.error('操作失败')
                }
                reject()
            })
    })
}
const change_cuikuan_flag = (record) => {
    let requestParam = {
        url: '/admin/v1/change_cuikuan_flag',
        method: 'post',
        data: {
            customer_id: record.id
        }
    }
    baseService(requestParam)
        .then((res: any) => {
            message.success(res.msg ? res.msg : '调整成功')
        })
        .catch((res) => {
            message.error(res.msg ? res.msg : '调整失败')
        })
}
const onCopyClick = (record) => {
    data.copyVisible = true
    record.isShowOptions = false
    data.tableColumnsData = { ...record, isCopy: true }
}

const handleOk = () => {
    data.createKey++
    data.visible = false
    data.refundVisible = false
    data.platformVisible = false
    data.editVisible = false
    data.copyVisible = false
    data.addressRenewVisible = false
    data.SFMailVisible = false
    data.directPaymentVisible = false
    loadData()
}
const handleCancel = () => {
    data.visible = false
    data.editVisible = false
    data.refundVisible = false
    data.copyVisible = false
    data.platformVisible = false
    data.addressRenewVisible = false
    data.SFMailVisible = false
    data.directPaymentVisible = false
}
const viewLogCancel = (isRefresh) => {
    if (isRefresh) {
        loadData()
    }
    data.visibleLog = false
}

const downLease = (downItem) => {
    if (downItem?.children?.length > 0) {
        return
    }
    let url = downItem.url.replace('https://console.cskaiyela.com/hncskaiyela', '')
    const hide = message.loading({
        content: '等待下载中,请稍等',
        duration: 0,
        class: 'loading-message'
    })
    let requestParam = {
        url: url,
        method: 'get'
    }
    baseService(requestParam)
        .then((res) => {
            let a = document.createElement('a')
            let event = new MouseEvent('click')
            a.download = ''
            a.href = downItem.url + `&token=${token}&down=1`
            a.dispatchEvent(event)
            setTimeout(hide, 2000)
        })
        .catch((res) => {
            setTimeout(hide, 500)
            if (res.msg) {
                message.error(res.msg)
            } else {
                message.error('操作失败,请联系管理员')
            }
        })
}
const change_exception_flag = (exception_flag, record) => {
    record.exception_flag = exception_flag
    if (exception_flag == 2) {
        record.exception_flag_seller_endtime = null
    }
}
const donwloadClick = (type) => {
    let href = 'https://hncs.cskaiyela.com/storage/public/uploads/模版库/芙蓉区通用开户资料.zip'
    let a = document.createElement('a')
    let event = new MouseEvent('click')
    a.download = ''
    a.href = href
    a.dispatchEvent(event)
}
const exportDataArgument = [
    '主体名称',
    '统一社会信用代码',
    '法人代表姓名',
    '注册地址',
    '合同开始时间',
    '合同结束时间',
    '主体类型',
    '入驻类型',
    '成立时间',
    '核准日期',
    '录入时间',
    '主体状态',
    '异常状态',
    '法人代表电话',
    '工商预留手机号码',
    '紧急联系人电话',
    '其他电话',
    '是否支付',
    '归属代理商',
    '财务会计电话(续费联系人)',
    '财务公司名称',
    '财务公司对接人姓名',
    '财务公司对接人电话',
    '财务公司统一社会信用代码',
    '销售价格',
    '来年续费价格'
]
const exportDataArgumentChecked = reactive({
    visible: false,
    companylist: '',
    checkedfieldSimple: ['主体名称', '统一社会信用代码', '法人代表姓名', '注册地址', '合同开始时间', '合同结束时间', '主体类型', '入驻类型', '成立时间', '核准日期', '录入时间', '主体状态', '异常状态'],
    checkedfieldAll: [
        '主体名称',
        '统一社会信用代码',
        '法人代表姓名',
        '注册地址',
        '合同开始时间',
        '合同结束时间',
        '主体类型',
        '入驻类型',
        '成立时间',
        '核准日期',
        '录入时间',
        '主体状态',
        '异常状态',
        '法人代表电话',
        '工商预留手机号码',
        '紧急联系人电话',
        '其他电话',
        '是否支付',
        '归属代理商',
        '财务会计电话(续费联系人)',
        '财务公司名称',
        '财务公司对接人姓名',
        '财务公司对接人电话',
        '财务公司统一社会信用代码',
        '销售价格',
        '来年续费价格'
    ],
    checkedfieldSimpleBak: [
        '主体名称',
        '统一社会信用代码',
        '法人代表姓名',
        '注册地址',
        '合同开始时间',
        '合同结束时间',
        '主体类型',
        '入驻类型',
        '成立时间',
        '核准日期',
        '录入时间',
        '主体状态',
        '异常状态'
    ]
})
const selectExportDataArgument = (type) => {
    if (type == 1) {
        exportDataArgumentChecked.checkedfieldSimple = exportDataArgumentChecked.checkedfieldSimpleBak
    } else if (type == 2) {
        exportDataArgumentChecked.checkedfieldSimple = exportDataArgumentChecked.checkedfieldAll
    } else {
        exportDataArgumentChecked.checkedfieldSimple = []
    }
}

const exportDatatab = ref('1')
const exportClick = (type) => {
    data.exportLoading = true
    exportDataArgumentChecked.visible = false
    queryParam.exportfield = exportDataArgumentChecked.checkedfieldSimple
    queryParam.type = type
    if (type == 2) {
        queryParam.companylist = exportDataArgumentChecked.companylist
    }
    let requestParam = {
        url: '/admin/v1/customerExport',
        method: 'post',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            responseType: 'blob'
        },
        data: queryParam
    }
    baseService(requestParam)
        .then((res) => {
            data.exportLoading = false
            message.success('下载成功')
        })
        .catch((res) => {
            data.exportLoading = false
            if (res.msg) {
                message.error(res.msg)
            } else {
                message.error('下载失败')
            }
        })
}
const toggleAdvanced = () => {
    data.advanced = !data.advanced
}

//发送催款通知
const sendCuikuan = () => {
    //判断必须带搜索条件
    let requestParam = {
        url: '/admin/v1/checkCuikuanWechat',
        method: 'post',
        data: queryParam
    }
    baseService(requestParam)
        .then((res) => {
            data.confirmSendWechat = true
            data.confirmSendWechatInfo = res.data
        })
        .catch((res) => {
            if (res.msg) {
                message.error(res.msg)
            } else {
                message.error('发送失败')
            }
        })
}
const sendCuikuanDo = () => {
    data.confirmSendWechat = false
    data.cuikuanLoading = true
    // ===== 附加模板 ID =====
    const requestData = {
        ...queryParam,
        template_id: data.selectedTemplateId,
    }
    let requestParam = {
        url: '/admin/v1/sendCuikuanWechat',
        method: 'post',
        data: requestData
    }
    baseService(requestParam)
        .then((res) => {
            data.cuikuanLoading = false
            message.success('发送成功,请等发财人客户端发送消息')
        })
        .catch((res) => {
            data.cuikuanLoading = false
            if (res.msg) {
                message.error(res.msg)
            } else {
                message.error('发送失败')
            }
        })
}
//导出待申报数据
let downloadInterval
const downloadsbException = () => {
    data.download_sbException_loading = true
    let requestParam = {
        url: '/admin/v1/downsbExcepiton',
        method: 'post',
        data: queryParam
    }
    baseService(requestParam)
        .then((res: any) => {
            if (res.msg == 1) {
                data.download_sbException_loading = false
                message.success(res.data)
            } else if (res.msg == 2) {
                //循环查询
                clearInterval(downloadInterval)
                downloadInterval = setInterval(() => {
                    let requestParam = {
                        url: `/admin/v1/downsbExcepiton`,
                        method: 'POST',
                        data: { rid: res.data }
                    }
                    baseService(requestParam)
                        .then((res2: any) => {
                            if (res2.msg == 3) {
                                //跳转地址下载
                                data.download_sbException_loading = false
                                let requestParam = {
                                    url: '/admin/v1/listZipDown',
                                    method: 'post',
                                    headers: {
                                        'Content-Type': 'application/x-www-form-urlencoded',
                                        responseType: 'blob'
                                    },
                                    data: { list: res2.data, file_name: '待申报地址异常资料', token: token }
                                }
                                baseService(requestParam)
                                    .then((res) => {
                                        message.success('下载成功')
                                    })
                                    .catch((res) => {
                                        if (res.msg) {
                                            message.error(res.msg)
                                        } else {
                                            message.error('下载失败')
                                        }
                                    })
                                clearInterval(downloadInterval)
                            } else if (res2.msg == 5) {
                                data.download_sbException_loading = false
                                message.error('下载失败！')
                                clearInterval(downloadInterval)
                            } else {
                                console.log(res2)
                            }
                        })
                        .catch((res) => { })
                }, 5000)
            }
        })
        .catch((res) => {
            data.download_sbException_loading = false
            if (res.msg) {
                message.error(res.msg)
            } else {
                message.error('获取待申报异常数据失败')
            }
        })
}



const piliang_shenbaoyichang = () => {
    const hide = message.loading({
        content: '操作中,请稍等',
        duration: 0,
        class: 'loading-message'
    })
    //得到本页的id
    let ids: any[] = []
    dataSource.value.forEach((item: any) => {
        ids.push(item.id)
    })

    ids.forEach((id: any) => {
        let requestParam = {
            url: '/admin/v1/change_anomaly_status',
            method: 'post',
            data: { customer_id: id, desc: '', endtime: 168, exception_flag: 2 }
        }
        baseService(requestParam)
            .then((res: any) => {
                message.success(res.msg)
            })
            .catch((res) => {
                if (res.msg) {
                    message.error(res.msg)
                } else {
                    message.error('操作失败')
                }
            })
            .finally(() => {
                setTimeout(hide, 0)
            })
    })
    setTimeout(hide, 10000)
    loadData()
}
//代理商确定待申报异常
const change_exception_seller = (record) => {
    if (!data.exception_remark) {
        message.error('请填写备注')
        return
    }
    let requestParam = {
        url: '/admin/v1/change_anomaly_seller',
        method: 'post',
        data: {
            id: record.id,
            remark: data.exception_remark,
            exception_url: data.exception_url
        }
    }
    baseService(requestParam)
        .then((res: any) => {
            message.success(res.msg)
            loadData()
        })
        .catch((res) => {
            if (res.msg) {
                message.error(res.msg)
            } else {
                message.error('操作失败,请联系管理员')
            }
        })
}
//公司确定待申报异常
const change_exception_fws = (record) => {
    if (!data.exception_remark) {
        message.error('请填写备注')
        return
    }
    let requestParam = {
        url: '/admin/v1/change_anomaly_fws',
        method: 'post',
        data: {
            id: record.id,
            remark: data.exception_remark,
            exception_url: data.exception_url
        }
    }
    baseService(requestParam)
        .then((res: any) => {
            message.success(res.msg)
            loadData()
        })
        .catch((res) => {
            if (res.msg) {
                message.error(res.msg)
            } else {
                message.error('操作失败,请联系管理员')
            }
        })
}
const editRemark = (record) => {
    let requestParam = {
        url: '/admin/v1/customer/editRemark',
        method: 'post',
        data: {
            id: record.id,
            remark: record.remark_new
        }
    }
    baseService(requestParam)
        .then((res: any) => {
            record.common_remark = res.data
            record.remarkEdit = false
            message.success(res.msg)
        })
        .catch((res) => {
            if (res.msg) {
                message.error(res.msg)
            } else {
                message.error('操作失败,请联系管理员')
            }
        })
}
</script>
<style lang="less" scoped>
.navlist {
    button {
        margin-right: 10px;
    }
}

.tabs {
    position: relative;

    .tabs-right {
        position: absolute;
        right: 0;
        top: 0;
        padding: 12px 0;
        display: flex;
        gap: 32px;
        align-items: center;
    }
}

:deep(.tableRowClass) {
    .ant-table-cell:first-child {
        padding: 0 !important;
    }
}

.table-operator {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 35px !important;
}

.customer-options-popover {
    p {
        padding: 0 16px;
        margin: 0;
        height: 35px;
        line-height: 35px;
        cursor: pointer;
        text-align: center;
        color: #000;
    }

    p:hover {
        color: var(--ant-primary-color);
        background: var(--ant-primary-color-deprecated-bg);
    }
}

.loading-message {
    .ant-message-notice-content {
        border: 1px solid #c8d8cf;
        color: rgb(8, 153, 68);
        background: rgb(233, 252, 241);
    }
}

.custom-tooltip-width {
    :global(.ant-tooltip-inner) {
        width: 400px;
    }
}

.tipsa {
    padding: 3px;
    float: left;
}
</style>
